<template>
  <div>
    Bevorzugter Zeitraum
    <ion-item lines="none">
      <ion-label>Von</ion-label>
      <ion-datetime
        placeholder="Bitte wählen"
        v-model="date"
        displayFormat="D. MMMM YYYY"
        :monthNames="monthNames"
        pickerFormat="D. MMMM YYYY"
        cancelText="Abbrechen"
        doneText="Fertig"
        :min="minDate"
      ></ion-datetime>
    </ion-item>
    <ion-item lines="none">
      <ion-label>Bis</ion-label>
      <ion-datetime
        placeholder="Bitte wählen"
        v-model="toDate"
        displayFormat="D. MMMM YYYY"
        :monthNames="monthNames"
        pickerFormat="D. MMMM YYYY"
        cancelText="Abbrechen"
        doneText="Fertig"
        :min="minDate"
      ></ion-datetime>
    </ion-item>
    <ion-item lines="none" class="ion-margin-top">
      <ion-label>Bevorzugte Zeit</ion-label>
      <ion-datetime
        placeholder="00:00"
        v-model="from"
        displayFormat="HH:mm"
        pickerFormat="HH:mm"
        cancelText="Abbrechen"
        doneText="Fertig"
      ></ion-datetime>
      &nbsp;bis&nbsp;
      <ion-datetime
        placeholder="00:00"
        v-model="to"
        displayFormat="HH:mm"
        pickerFormat="HH:mm"
        cancelText="Abbrechen"
        doneText="Fertig"
      ></ion-datetime>
    </ion-item>
    <next-question-button
      @click="
        $emit('done', {
          value:
            (date ? date.substring(0, 10) : '') +
            ' - ' +
            (toDate ? toDate.substring(0, 10) : '') +
            ' von ' +
            (from ? from.substring(11, 16) : '') +
            ' bis ' +
            (to ? to.substring(11, 16) : ''),
          id: question.id,
        })
      "
    />
  </div>
</template>

<script>
import NextQuestionButton from "./NextQuestionButton";
import { IonItem, IonLabel, IonDatetime } from "@ionic/vue";

const today = new Date();
const tomorrow = new Date(today);
tomorrow.setDate(tomorrow.getDate() + 1);

export default {
  components: {
    NextQuestionButton,
    IonItem,
    IonLabel,
    IonDatetime,
  },
  props: {
    question: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      date: "",
      toDate: "",
      from: "",
      to: "",
      minDate: tomorrow.toISOString(),
      monthNames: [
        "Jänner",
        "Februar",
        "März",
        "April",
        "Mai",
        "Juni",
        "Juli",
        "August",
        "September",
        "Oktober",
        "November",
        "Dezember",
      ],
    };
  },
};
</script>

<style></style>
